function clone(obj) {
    return JSON.parse(JSON.stringify(obj));
}

function isJSON(str) {
    var result;

    try {
        result = JSON.parse(str);
    } catch (e) {
        return false;
    }
    return result;
}

function fixFP(number, maxError) {
    return parseFloat(number.toFixed(maxError));
}

// Function to ofuscate email addresses
function sendEmail(user, domain) {
    dest = 'mailto:' + user + '@' + domain;
    location.href = dest;

    return false;
}